import * as React from 'react'
import { observer } from 'mobx-react'
import styles from '../../styles.sass'
import { Form, FormRow, TextInputContainer } from 'components/inputs'
import ButtonCollection from 'components/ButtonCollection'
import Button from 'components/Button'
import WorkspaceSignupState from '../WorkspaceSignupState'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  workspaceSignupState: WorkspaceSignupState
}

export default observer(function MemberSignupView({
  workspaceSignupState,
}: Props) {
  return (
    <div className={styles.content}>
      <Form
        className={styles.inputGroup}
        onSubmit={() => workspaceSignupState.trySyncMember()}
      >
        <FormRow>
          <TextInputContainer
            className={styles.input}
            model={workspaceSignupState}
            field="givenName"
            label="First Name"
            error={workspaceSignupState.validation.getError('givenName')}
            placeholder="e.g. John"
          />
        </FormRow>
        <FormRow>
          <TextInputContainer
            className={styles.input}
            model={workspaceSignupState}
            field="familyName"
            label="Last Name"
            error={workspaceSignupState.validation.getError('familyName')}
            placeholder="e.g. Smith"
          />
        </FormRow>
        <FormRow>
          <TextInputContainer
            className={styles.input}
            model={workspaceSignupState}
            field="email"
            label="Email Address"
            error={workspaceSignupState.validation.getError('email')}
            placeholder="john.smith@my-company.com"
          />
        </FormRow>
        <FormRow>
          <TextInputContainer
            className={styles.input}
            model={workspaceSignupState}
            field="phone"
            label="Phone"
            error={workspaceSignupState.validation.getError('phone')}
            placeholder="(123) 456-7890"
          />
        </FormRow>
        <ButtonCollection>
          <Button
            type="primary"
            submit
            disabled={workspaceSignupState.trySyncMember.pending}
            loading={workspaceSignupState.trySyncMember.pending}
          >
            Register
          </Button>
          {workspaceSignupState.configurerView !== 'register' && (
            <Button
              disabled={workspaceSignupState.trySyncMember.pending}
              onClick={() => workspaceSignupState.setConfigurerView('search')}
            >
              Back
            </Button>
          )}
        </ButtonCollection>
      </Form>
    </div>
  )
})
